export const features = {
  free: ["links", "stats", "scans", "bulk"],
  pro1: ["links", "stats", "domain", "support"],
  pro2: ["links", "domain", "team", "sso", "api"],
  growth: ["links", "domain", "team", "account"],
  custom: ["links", "domain", "team", "addons"]
}

export const usageLimits = {
  FREE: ["links", "scans"],
  PREMIUM: ["links", "scans", "domains"],
  DEMO: ["domains"]
}

export const featureLimitKey = {
  links: "qr",
  domains: "domain"
}
